export default __webpack_public_path__ + "static/media/Chat-Numbers-System-04.190a4227.svg";